import React, { useState } from "react";
import DocMenus from "./DocMenus";
import DocSearchBlock from "./DocSearchBlock";
import '../../../assets/css/common/document/sidebar_list.scss';
import LoadMore from "../../../components/common/LoadMore/index";
import LoaderUI from "../../../components/common/loader/index";
import TotalCount from "../../../components/common/TotalCount";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh, faRedoAlt } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import TimezoneClock from "../../../components/common/TimeZone";
import { useDispatch, useSelector } from "react-redux";
import {getPendingIRSIncomeDetail} from "../../../context/actions/irsIncome"
import {
	Collapse,
} from "reactstrap";

const SidebarList = ({ activeId, list, _filter, __filter, _resetFilter, page, search, handlePageChange, handleElasticSearch, elasticSearchList, focusSearchFlag, _focusSearch, filter, totalRecords, sortBySelected, _sortBySelected, filterSelected, _filterSelected, folderRefreshFlag, status, sort, order, sortOrder, incomeAnalyzerDetail, getPendingIRSIncome,pendingIrsIncomeLoanNumber }) => {


	const [openRows, setOpenRows] = useState({"0 0": true});

	const dispatch = useDispatch();

	const toggleRow = (index) => {
		setOpenRows((prevState) => ({
			// ...prevState,
			[index]: !prevState[index],
		}));
	};
	const _handlePageChange = (activePage) => {
		handlePageChange(activePage);
	};

	const _refreshFolders = () => {
		// refreshFolders();
	}

	// const getPendingIRSIncomeDetail = (loan_nmber) => {
	// 	dispatch(
	// 		getPendingIRSIncomeDetail(loan_nmber, async (res) => {
	// 		})
	// 	  );
	// }

	const userDetail = useSelector((state) => state?.user?.user);
	return (
		<>

			<div className="sidebar-list d-flex flex-column flex-fill overflow-auto">
				<DocSearchBlock _resetFilter={_resetFilter} _handleSearch={(val, moreInfo) => search(val, moreInfo)} _filterDocs={_filter} __filterDocs={__filter} __sortBySelected={_sortBySelected} sortBySelected={sortBySelected} filterSelected={filterSelected} __filterSelected={_filterSelected} _handleElasticSearch={(val) => handleElasticSearch(val)} elasticSearchList={elasticSearchList} focusSearchFlag={focusSearchFlag} __focusSearch={(val => _focusSearch(val))} filter={filter} status={status} sort={sort} order={order} sortOrder={sortOrder} />
				<div className="refresh-list-hd d-flex align-items-center">
					{<TotalCount className="sidebarListBlc" name="Loan List" records={totalRecords} />} {/*records={totalFolderRecords}*/}



				</div>
				<div className="inner-blc  d-flex flex-column flex-fill overflow-auto position-relative">
					{list.length ?
						list.map((_val, listIndex) => {
							return (
								<div className="loan-list-block">
									<div className="head" style={{ borderBottom: "1px solid #eee" }}>
									<p className="value_id">{_val._id}</p>	
									{/* <div> */}
								
									{/* </div> */}
									</div>
									{_val?.borrower_name?.length && _val.borrower_name.map((item, index) => {
										return (<div className="inner">
											<div onClick={() => toggleRow(listIndex + " " + index)} className={`loan-item-cell ${activeId === item?._id ? `active` : ``} ${openRows[listIndex + " " + index] ? "active-accordion-header" : ""}`} >
												<div className="label-arw">
													<span className="icon">
														<svg
															width="14"
															height="11"
															viewBox="0 0 14 11"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M7 11L0.937823 0.499999L13.0622 0.5L7 11Z"
																fill="#3461FF"
															/>
														</svg>
													</span>
													{item.name}
												</div>
												<div className="head d-flex align-items-center">
													<label>{item?.borrower_name}</label>
													{/* <span className={`ms-auto ${item?.tax_status == 'Pending' ? 'inprogress-lbl' : item?.tax_status == 'Ready' ? 'success-lbl' : 'error-lbl' }`}>{item?.tax_status}</span> */}
												</div>
												{/* <div className="inner">
												
														<p>
															Request Submitted on <span>{
															(item?.createdAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={item?.createdAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail.timezone} dateTime={item?.createdAt} timeFormat={"h:mm a"} /></> :
															  moment(item?.createdAt).format(
																"MMM DD,YYYY"
															) + ' at ' + moment(item?.createdAt).format(
																"h:mm a"
															)}</span>
														</p>


													</div> */}

											</div>
											<Collapse isOpen={openRows[listIndex + " " + index] || false}>
												{item?.docs?.length && item?.docs?.map((employer, key) => {
													return (
														<div className={`loan-item-cell ${activeId === employer?._id ? `active` : ``}`} onClick={() => incomeAnalyzerDetail(employer?._id, listIndex, index, key)}>
															<div className="head d-flex align-items-center">
																<label style={{ marginLeft: '15px' }}>{employer?.record_label}</label>
																{/* <span className={`ms-auto ${item?.tax_status == 'Pending' ? 'inprogress-lbl' : item?.tax_status == 'Ready' ? 'success-lbl' : 'error-lbl' }`}>{item?.tax_status}</span> */}
															</div>

															{/* <div className="inner">

															<p>
																Request Submitted on <span>{
																(item?.createdAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={item?.createdAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail.timezone} dateTime={item?.createdAt} timeFormat={"h:mm a"} /></> :
																moment(item?.createdAt).format(
																	"MMM DD,YYYY"
																) + ' at ' + moment(item?.createdAt).format(
																	"h:mm a"
																)}</span>
															</p>


														</div> */}

														</div>
													)
												})}
											</Collapse>
											<div>

											</div>
										</div>)
									})
									}
								</div>
							)
						}
						) : ''}
				</div>
				{list.length < totalRecords && <LoadMore page={page} __handlePageChange={(activePage) => _handlePageChange(activePage)} loading={false} label={'View More'} />}
			</div>
		</>
	);
};
export default SidebarList;
